export const SERVICE_AUTHORIZATION_FILTER_KEYWORD = '@ca:service-authorization:filter:keyword';
export const SERVICE_AUTHORIZATION_FILTER_CRITERIA = '@ca:service-authorization:filter:criteria';